// import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import {
  apiUrl,
  bannerImgUrl,
  goodsImgUrl,
  imgUrlTvee,
} from '../../common/urls';

const ShopBannerCard_ = ({ banner }) => {
  const isMobile = useMediaQuery({ query: '(max-width:768px)' });
  const [style, setStyle] = useState({
    background: banner.backgroundColor,
    color: '#fff',
  });

  const [img, setImg] = useState(null);

  const _goLink = (url) => {
    console.log(url);
    window.open(url);
  };
  useEffect(() => {
    setImg(isMobile ? banner.mobileImg : banner.img);
    setStyle(
      isMobile
        ? { color: '#fff', background: 'transparent' }
        : { color: banner.fontColor, background: banner.backgroundColor }
    );
  }, [
    isMobile,
    banner.mobileImg,
    banner.img,
    banner.fontColor,
    banner.bgColor,
  ]);

  return (
    <div
      onClick={() =>
        _goLink(
          banner.contentSerial > 0
            ? `https://shop.aniplustv.com/item/${banner.contentSerial}`
            : isMobile
            ? banner.mobileLink
            : banner.link
        )
      }
      style={{ cursor: 'pointer' }}
    >
      <div
        className={`banner-item ${banner.contentSerial > 0 ? 'goods' : ''}`}
        style={{ backgroundColor: style.background }}
      >
        {banner.video && (
          <div className="background-video">
            <video
              src={banner.video}
              controls={false}
              muted={false}
              autoPlay={true}
              loop={true}
              playsInline={true}
            />
          </div>
        )}
        <div className="text-area">
          <span className="badge" style={{ color: style.color }}>
            {banner.comment}
          </span>
          <div className="title" style={{ color: style.color }}>
            {banner.title}
          </div>
          <span className="subtitle" style={{ color: style.color }}>
            {banner.subTitle}
          </span>
        </div>
        <div className="img-area">
          {img && (
            <img
              src={
                banner.contentSerial > 0
                  ? imgUrlTvee + '/images/tvee-admin/shopping/' + img
                  : bannerImgUrl + '/' + img
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopBannerCard_;
